import { translate } from "app/filters/i18nFilter";
import type { IAgeBucketID, IAgeBucketIDs } from "app/UtilitiesAndConstants/types/age";

// returns the selected text as following:
//18-24 -> 18-24
//18-24 && 25-34 -> 18-24 or 25-34
//18-24 && 25-34 && 35-44 -> 18-24 or 25-34 +1 other
//18-24 && 25-34 && 35-44 && 45-54 -> 18-24 or 25-34 +2 others

export const resolveSelectedTextHOF =
    (items: Array<{ id: IAgeBucketID; textKey: string }>) =>
    (ageBucketIDs: IAgeBucketIDs): string | undefined => {
        if (ageBucketIDs.length === 0) {
            return undefined;
        }
        if (ageBucketIDs.includes(items[0].id) || ageBucketIDs.length === 6) {
            return translate("demographics.user.based.compare.table.filters.age.all");
        }
        const filteredItems = items.filter(({ id }) => ageBucketIDs.includes(id));
        if (ageBucketIDs.length === 1) {
            return translate(filteredItems[0].textKey);
        }
        const baseText = `${translate(filteredItems[0].textKey)} ${translate("common.or")} ${translate(
            filteredItems[1].textKey,
        )}`;
        if (ageBucketIDs.length === 2) {
            return baseText;
        }
        if (ageBucketIDs.length === 3) {
            return `${baseText} +1 ${translate("common.other")}`;
        }
        return `${baseText} + ${ageBucketIDs.length - 2} ${translate("common.others")}`;
    };
